import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogBody,
} from '@axa-asia/emma-stylesheet/lib/components/Dialog';
import {
  triggerPopupDisplayScreenChange,
  triggerPopupCloseScreenChange,
} from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaPreviousScreenUtil';
import arrow from '../../../../assets/images/arrow_right_grey_small.png';
import './style.scss';
import {
  getContactDetailsLabels,
  getContactDetailsPolicy,
} from '../../selectors/contactDetailsSelector';
import { isApp, resolveLocalizedText } from '../../../../utils';
import { getErrorCode } from '../../utils';
import { goto } from '../../../../actions/historyActions';
import { t } from '../../../../locales';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import _ from 'lodash';
import { saveSelectedPolicy } from '../../actions/changeContactAction';
import { resetChangeEmailForm } from '../../actions/changeEmailAction';
import { resetChangeMobileForm } from '../../actions/changeMobileAction';
import BackNavButton from '../../components/BackNavButton';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import browserHistory from '../../../../stores/browserHistory';
import { extractCountryCode } from '../../../../utils/common';
import { controlTopbarOverlay } from '../../../../utils/AppUtils';
import { getChangeMobileLabels } from '../../selectors/updateMobileSelector';
import { UserTypeCodes, ContactInfoStatuses } from '../../constants/constants';
import {
  ContactInfoStatusType,
  UserTypes,
} from '../../types/changeContactService';
import { EntityCode } from '../../../../types/entityCodeTypes';
import { ENTITY_CODE } from '../../../../constants/constants';
import {
  ADDRESS_ERROR_CICER21,
  ADDRESS_ERROR_CICER22,
  ADDRESS_ERROR_CICER25,
  ADDRESS_ERROR_CICER24,
  HAPPY_HK_CASE,
} from '../../constants/constants';
import {
  clearAddressForm,
  setUpIsHKAddressCase,
  updateIsGoogleMapJsScriptError,
} from '../../actions/changeAddressAction';
import { getIsGoogleMapJsScriptComplete } from '../../selectors/changeAddressSelector';
import {
  gaClickAbleElement,
  trackDisplayErrorSuccess,
} from '../../../../utils/generalGaEventAnalytics';

export interface ContactDetailsContainerProps {
  contactDetailsLabel: any;
  policyCardLabel: any;
  policyDetails: any;
  changeMobileLabels: any;
  errorCodeCICER21Config: any;
  errorCodeCICER22Config: any;
  errorCodeCICER25Config: any;
  errorCodeCICER24Config: any;
  saveSelectedPolicy: (policy: any) => void;
  resetChangeEmailForm: () => void;
  resetChangeMobileForm: () => void;
  onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => void;
  onUpdateIsGoogleMapJsScriptError: (isError: boolean) => void;
  clearAddressForm: () => void;
}

export interface ContactDetailsContainerState {
  downloadModal: boolean;
  inEligibleAddressUpdateReasonCode: string;
  inEligibleEmailMobileUpdateReasonCode: string;
}

export class ContactDetailsContainer extends Component<
  ContactDetailsContainerProps,
  ContactDetailsContainerState
> {
  constructor(props: ContactDetailsContainerProps) {
    super(props);
    this.state = {
      downloadModal: false,
      inEligibleAddressUpdateReasonCode: '',
      inEligibleEmailMobileUpdateReasonCode: '',
    };
  }

  gotoUpdateMobile = () => {
    const { policyDetails } = this.props;
    const { inEligibleEmailMobileUpdateReasonCode } = policyDetails;
    // null will bypass default value in destructive assignment
    const mobile: string = policyDetails.mobile || '';

    const { countryCode } = extractCountryCode(mobile);

    if (mobile && countryCode === '') {
      this.setState({
        downloadModal: true,
      });
      controlTopbarOverlay(true);
    } else if (
      inEligibleEmailMobileUpdateReasonCode &&
      inEligibleEmailMobileUpdateReasonCode !== HAPPY_HK_CASE
    ) {
      this.setState({
        inEligibleEmailMobileUpdateReasonCode,
      });
      controlTopbarOverlay(true);
      triggerPopupDisplayScreenChange(inEligibleEmailMobileUpdateReasonCode);
      // #70
      trackDisplayErrorSuccess(inEligibleEmailMobileUpdateReasonCode);
    } else {
      goto('emma-customer-profile/changemobile');
    }
  };

  gotoChangeEmail = () => {
    const { policyDetails } = this.props;
    const { inEligibleEmailMobileUpdateReasonCode } = policyDetails;
    if (
      inEligibleEmailMobileUpdateReasonCode &&
      inEligibleEmailMobileUpdateReasonCode !== HAPPY_HK_CASE
    ) {
      this.setState({
        inEligibleEmailMobileUpdateReasonCode,
      });
      triggerPopupDisplayScreenChange(inEligibleEmailMobileUpdateReasonCode);
      // #70
      trackDisplayErrorSuccess(inEligibleEmailMobileUpdateReasonCode);
    } else {
      goto('emma-customer-profile/changeemail');
    }
  };

  gotoChangeAddress = () => {
    const { policyDetails } = this.props;
    const { inEligibleAddressUpdateReasonCode, addressStatus } = policyDetails;
    if (
      inEligibleAddressUpdateReasonCode &&
      inEligibleAddressUpdateReasonCode !== HAPPY_HK_CASE
    ) {
      this.setState({
        inEligibleAddressUpdateReasonCode,
      });
      controlTopbarOverlay(true);
      triggerPopupDisplayScreenChange(inEligibleAddressUpdateReasonCode);
      // #70
      trackDisplayErrorSuccess(inEligibleAddressUpdateReasonCode);
    } else {
      this.props.onSetUpIsHKAddressCase(true);
      this.props.onUpdateIsGoogleMapJsScriptError(false);
      goto('emma-customer-profile/changeaddress/edit');
    }
  };

  componentDidMount() {
    const {
      resetChangeEmailForm,
      resetChangeMobileForm,
      policyDetails,
      saveSelectedPolicy,
      clearAddressForm,
    } = this.props;
    clearAddressForm();
    if (isApp()) {
      const title = t(`CUSTOMER_PROFILE_CONTACT_DETAILS_TITLE`);
      if (title) {
        EmmaFactory.createInstance().then((p) =>
          p.instance.setNavigationTitle(title),
        );
      }
    }

    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    } else {
      saveSelectedPolicy(policyDetails);
    }

    resetChangeEmailForm();
    resetChangeMobileForm();
  }

  onGoBack = () => {
    browserHistory.goBack();
    // goto('emma-change-contact');
  };

  hideDownloadModal = () => {
    this.setState({ downloadModal: false });
    controlTopbarOverlay(false);
  };

  hideErrorModal = () => {
    this.setState({
      inEligibleAddressUpdateReasonCode: '',
      inEligibleEmailMobileUpdateReasonCode: '',
    });
    controlTopbarOverlay(false);
    triggerPopupCloseScreenChange();
  };

  render() {
    const {
      contactDetailsLabel,
      policyDetails,
      changeMobileLabels,
      errorCodeCICER21Config,
      errorCodeCICER22Config,
      errorCodeCICER24Config,
      errorCodeCICER25Config,
    } = this.props;
    const {
      contactDetailsTitle,
      mobileLabel,
      emailLabel,
      title,
      contactDetailsText,
      contactDetailsEnquiry,
      contactDetailsRemark,
      addressLabel,
      addressOnYourPolicy,
      addresRemark,
    } = contactDetailsLabel;
    const {
      policyNumber,
      certificateNumber,
      mobileDisplay,
      mobileText,
      emailText,
      planName,
      addressText,
    } = policyDetails;
    const {
      mobileStatus,
      emailStatus,
      addressStatus,
      userType,
      entityCode,
    }: {
      mobileStatus: ContactInfoStatusType;
      emailStatus: ContactInfoStatusType;
      addressStatus: ContactInfoStatusType;
      userType: UserTypes;
      entityCode: EntityCode;
    } = policyDetails;
    const pageTitle = title ? resolveLocalizedText(title) : '';
    const {
      inEligibleAddressUpdateReasonCode,
      inEligibleEmailMobileUpdateReasonCode,
      downloadModal,
    } = this.state;
    const {
      downloadBtn,
      cancelBtn,
      downloadModalTitle,
      downloadModalContent,
      downloadUrl,
    } = changeMobileLabels;
    const isShowDetailRemark =
      mobileStatus === ContactInfoStatuses.UPDATING ||
      emailStatus === ContactInfoStatuses.UPDATING;
    const detailRemarkText =
      entityCode === ENTITY_CODE.GHK || entityCode === ENTITY_CODE.G4HK
        ? t('CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_2')
        : t('CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_1');
    const detailRemarkTextEmail = detailRemarkText.replace(
      '${progressType}',
      t('CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_EMAIL'),
    );
    const detailRemarkTextMobile = detailRemarkText.replace(
      '${progressType}',
      t('CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_MOBILE'),
    );
    const detailRemarkTextBoth = detailRemarkText.replace(
      '${progressType}',
      t('CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_BOTH'),
    );
    const detailRemarkProgessText =
      mobileStatus === ContactInfoStatuses.UPDATING &&
      emailStatus === ContactInfoStatuses.UPDATING
        ? detailRemarkTextBoth
        : emailStatus === ContactInfoStatuses.UPDATING
        ? detailRemarkTextEmail
        : mobileStatus === ContactInfoStatuses.UPDATING
        ? detailRemarkTextMobile
        : '';
    const detailRemarkWorkingDayText =
      entityCode === ENTITY_CODE.GHK ||
      entityCode === ENTITY_CODE.G4HK ||
      entityCode === ENTITY_CODE.EHK
        ? detailRemarkProgessText.replace('${workingDay}', '6')
        : detailRemarkProgessText.replace('${workingDay}', '8');

    return (
      <div className="contact-details-wrap">
        <div className="customer-profile-backbutton">
          <BackNavButton onClick={this.onGoBack} blue title={t('BACK')} />
        </div>
        <div className="contact-details-container emma-stylesheet-grid-system">
          <EmmaNavTitle
            title={pageTitle}
            component={<CustomerProfileTitle customerTitle={pageTitle} />}
          />
          <div className="contact-info-section">
            <div>
              {contactDetailsText
                ? resolveLocalizedText(contactDetailsText)
                : ''}
            </div>
            <div className="contact-details-policy">
              <div className="contact-details-policy-title">{planName}</div>
              <div>
                PN: {policyNumber}
                {userType === UserTypeCodes.EHK && (
                  <span className="ml12">CN: {certificateNumber}</span>
                )}
              </div>
            </div>
            <div className="label">
              {contactDetailsTitle
                ? resolveLocalizedText(contactDetailsTitle)
                : ''}
            </div>
            <div className="contact-info-wrapper">
              {mobileDisplay &&
                (mobileStatus === ContactInfoStatuses.UPDATING ? (
                  <div className="row info-button">
                    <div className="col-4 info-label">
                      {mobileLabel ? resolveLocalizedText(mobileLabel) : ''}
                    </div>
                    <div
                      className={`col-8 info-value contact-details-value-gray`}
                    >
                      {mobileText}
                    </div>
                  </div>
                ) : (
                  <div
                    className="row info-button info-button-cursor"
                    data-enable-ga
                    data-ga-type="button"
                    data-ga-text={
                      mobileLabel ? resolveLocalizedText(mobileLabel) : ''
                    }
                    onClick={this.gotoUpdateMobile}
                  >
                    <div className="col-4 info-label">
                      {mobileLabel ? resolveLocalizedText(mobileLabel) : ''}
                    </div>
                    <div
                      className={`col-8 info-value ${
                        mobileStatus === ContactInfoStatuses.VALID
                          ? ''
                          : 'contact-details-value-gray'
                      }`}
                    >
                      {mobileText}
                      <div className="icon-wrapper">
                        <img className="arrow-right" src={arrow} alt="" />
                      </div>
                    </div>
                  </div>
                ))}
              {emailStatus === ContactInfoStatuses.UPDATING ? (
                <div className="row info-button">
                  <div className="col-4 info-label">
                    {emailLabel ? resolveLocalizedText(emailLabel) : ''}
                  </div>
                  <div
                    className={`col-8 info-value contact-details-value-gray`}
                  >
                    {' '}
                    {emailText}
                  </div>
                </div>
              ) : (
                <div
                  className="row info-button info-button-cursor"
                  data-enable-ga
                  data-ga-type="button"
                  data-ga-text={
                    emailLabel ? resolveLocalizedText(emailLabel) : ''
                  }
                  onClick={this.gotoChangeEmail}
                >
                  <div className="col-4 info-label">
                    {emailLabel ? resolveLocalizedText(emailLabel) : ''}
                  </div>
                  <div
                    className={`col-8 info-value ${
                      emailStatus === ContactInfoStatuses.VALID
                        ? ''
                        : 'contact-details-value-gray'
                    }`}
                  >
                    {emailText}
                    <div className="icon-wrapper">
                      <img className="arrow-right" src={arrow} alt="" />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {userType === UserTypeCodes.LHK && (
              <div className="contact-info-section-address">
                <div className="contact-info-section-address-title">
                  {addressOnYourPolicy
                    ? resolveLocalizedText(addressOnYourPolicy)
                    : ''}
                </div>
                {addressStatus === ContactInfoStatuses.UPDATING ? (
                  <div className="contact-info-section-address-wrapper">
                    <div className="contact-info-section-address-wrapper-left">
                      <div className="contact-info-section-address-wrapper-left content-align-level">
                        <div className="contact-info-section-address-wrapper-left-title">
                          {addressLabel
                            ? resolveLocalizedText(addressLabel)
                            : ''}
                        </div>
                      </div>
                      <div
                        className={`contact-info-section-address-wrapper-left-value contact-details-value-gray`}
                      >
                        {addressText}
                      </div>
                    </div>
                    {/* <div className="contact-info-section-address-wrapper-right">
                </div> */}
                  </div>
                ) : (
                  <div
                    className="contact-info-section-address-wrapper"
                    data-enable-ga
                    data-ga-type="button"
                    data-ga-text={
                      addressLabel ? resolveLocalizedText(addressLabel) : ''
                    }
                    onClick={this.gotoChangeAddress}
                  >
                    <div className="contact-info-section-address-wrapper-left">
                      <div className="contact-info-section-address-wrapper-left-title">
                        {addressLabel ? resolveLocalizedText(addressLabel) : ''}
                      </div>
                      <div
                        className={`contact-info-section-address-wrapper-left-value ${
                          addressStatus === ContactInfoStatuses.VALID
                            ? ''
                            : 'contact-details-value-gray'
                        }`}
                      >
                        {addressText}
                      </div>
                    </div>
                    <div className="contact-info-section-address-wrapper-right">
                      <img className="arrow-right" src={arrow} alt="" />
                    </div>
                  </div>
                )}
                <div className="contact-info-section-address-remark contact-info-section-address-wrapper-cursor">
                  {addresRemark ? resolveLocalizedText(addresRemark) : ''}
                </div>
              </div>
            )}
            {isShowDetailRemark && (
              <div className="contact-details-remark">
                {detailRemarkWorkingDayText}
              </div>
            )}
            {entityCode === ENTITY_CODE.GHK ||
            entityCode === ENTITY_CODE.G4HK ? (
              <div className="contact-info-remark">
                <div className="contact-info-remark__title">
                  {t('CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK1')}
                </div>
                <div className="contact-info-remark__description">
                  {t('CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK2')}
                  {/* {t('CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK3')} */}
                </div>
              </div>
            ) : contactDetailsEnquiry ? (
              <div className="contact-details-enquiry">
                {resolveLocalizedText(contactDetailsEnquiry)}
              </div>
            ) : null}
          </div>
          <Dialog show={downloadModal}>
            <DialogHeader>
              <span>
                {downloadModalTitle
                  ? resolveLocalizedText(downloadModalTitle)
                  : ''}
              </span>
            </DialogHeader>
            <DialogBody>
              <div className="download-modal-content">
                {downloadModalContent
                  ? resolveLocalizedText(downloadModalContent)
                  : ''}
              </div>
            </DialogBody>
            <DialogFooter>
              <a target="_blank" rel="noopener noreferrer" href={downloadUrl}>
                <button
                  data-enable-ga
                  data-ga-type="button"
                  className="emma-stylesheet-primary-default-button"
                >
                  {downloadBtn ? resolveLocalizedText(downloadBtn) : ''}
                </button>
              </a>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  this.hideDownloadModal();
                }}
              >
                {cancelBtn ? resolveLocalizedText(cancelBtn) : ''}
              </button>
            </DialogFooter>
          </Dialog>
          {/* Suspicious case */}
          <Dialog
            show={
              inEligibleAddressUpdateReasonCode === ADDRESS_ERROR_CICER21 ||
              inEligibleEmailMobileUpdateReasonCode === ADDRESS_ERROR_CICER21
            }
          >
            <DialogHeader>
              {errorCodeCICER21Config.title
                ? resolveLocalizedText(errorCodeCICER21Config.title)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="Non-HK-address-modal-content">
                <div className="Non-HK-address-modal-content-section1">
                  {errorCodeCICER21Config.desc
                    ? resolveLocalizedText(errorCodeCICER21Config.desc)
                    : ''}
                </div>
              </div>
            </DialogBody>
            <DialogFooter>
              <a target="_blank" rel="noopener noreferrer" href={downloadUrl}>
                <button
                  className="emma-stylesheet-primary-default-button"
                  onClick={() => {
                    gaClickAbleElement(
                      errorCodeCICER21Config.buttons &&
                        errorCodeCICER21Config.buttons[0] &&
                        errorCodeCICER21Config.buttons[0].label
                        ? resolveLocalizedText(
                            errorCodeCICER21Config.buttons[0].label,
                          )
                        : '',
                      ADDRESS_ERROR_CICER21,
                    );
                  }}
                >
                  {errorCodeCICER21Config.buttons &&
                  errorCodeCICER21Config.buttons[0] &&
                  errorCodeCICER21Config.buttons[0].label
                    ? resolveLocalizedText(
                        errorCodeCICER21Config.buttons[0].label,
                      )
                    : ''}
                </button>
              </a>
              <button
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  gaClickAbleElement(
                    errorCodeCICER21Config.buttons &&
                      errorCodeCICER21Config.buttons[1] &&
                      errorCodeCICER21Config.buttons[1].label
                      ? resolveLocalizedText(
                          errorCodeCICER21Config.buttons[1].label,
                        )
                      : '',
                    ADDRESS_ERROR_CICER21,
                  );
                  this.hideErrorModal();
                }}
              >
                {errorCodeCICER21Config.buttons &&
                errorCodeCICER21Config.buttons[1] &&
                errorCodeCICER21Config.buttons[1].label
                  ? resolveLocalizedText(
                      errorCodeCICER21Config.buttons[1].label,
                    )
                  : ''}
              </button>
            </DialogFooter>
          </Dialog>
          {/* data issue case */}
          <Dialog
            show={
              inEligibleAddressUpdateReasonCode === ADDRESS_ERROR_CICER22 ||
              inEligibleEmailMobileUpdateReasonCode === ADDRESS_ERROR_CICER22
            }
          >
            <DialogHeader>
              {errorCodeCICER22Config.title
                ? resolveLocalizedText(errorCodeCICER22Config.title)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="data-issue-address-modal-content">
                {errorCodeCICER22Config.desc
                  ? resolveLocalizedText(errorCodeCICER22Config.desc)
                  : ''}
              </div>
            </DialogBody>
            <DialogFooter>
              <button
                className="emma-stylesheet-primary-default-button"
                onClick={() => {
                  gaClickAbleElement(
                    errorCodeCICER22Config.buttons &&
                      errorCodeCICER22Config.buttons[0] &&
                      errorCodeCICER22Config.buttons[0].label
                      ? resolveLocalizedText(
                          errorCodeCICER22Config.buttons[0].label,
                        )
                      : '',
                    ADDRESS_ERROR_CICER22,
                  );
                  this.hideErrorModal();
                  const url =
                    errorCodeCICER22Config.buttons[0].deepLink.query.url;
                  goto(`${url}`);
                }}
              >
                {errorCodeCICER22Config.buttons &&
                errorCodeCICER22Config.buttons[0] &&
                errorCodeCICER22Config.buttons[0].label
                  ? resolveLocalizedText(
                      errorCodeCICER22Config.buttons[0].label,
                    )
                  : ''}
              </button>
              <button
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  gaClickAbleElement(
                    errorCodeCICER22Config.buttons &&
                      errorCodeCICER22Config.buttons[1] &&
                      errorCodeCICER22Config.buttons[1].label
                      ? resolveLocalizedText(
                          errorCodeCICER22Config.buttons[1].label,
                        )
                      : '',
                    ADDRESS_ERROR_CICER22,
                  );
                  this.hideErrorModal();
                }}
              >
                {errorCodeCICER22Config.buttons &&
                errorCodeCICER22Config.buttons[1] &&
                errorCodeCICER22Config.buttons[1].label
                  ? resolveLocalizedText(
                      errorCodeCICER22Config.buttons[1].label,
                    )
                  : ''}
              </button>
            </DialogFooter>
          </Dialog>
          {/* Happy non-HK case */}
          <Dialog
            show={inEligibleAddressUpdateReasonCode === ADDRESS_ERROR_CICER24}
          >
            <DialogHeader>
              {errorCodeCICER24Config.title
                ? resolveLocalizedText(errorCodeCICER24Config.title)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="Non-HK-address-modal-content">
                <div className="Non-HK-address-modal-content-section1">
                  {errorCodeCICER24Config.desc
                    ? resolveLocalizedText(errorCodeCICER24Config.desc)
                    : ''}
                </div>
              </div>
            </DialogBody>
            <DialogFooter>
              <a target="_blank" rel="noopener noreferrer" href={downloadUrl}>
                <button
                  className="emma-stylesheet-primary-default-button"
                  onClick={() => {
                    gaClickAbleElement(
                      errorCodeCICER24Config.buttons &&
                        errorCodeCICER24Config.buttons[0] &&
                        errorCodeCICER24Config.buttons[0].label
                        ? resolveLocalizedText(
                            errorCodeCICER24Config.buttons[0].label,
                          )
                        : '',
                      ADDRESS_ERROR_CICER24,
                    );
                  }}
                >
                  {errorCodeCICER24Config.buttons &&
                  errorCodeCICER24Config.buttons[0] &&
                  errorCodeCICER24Config.buttons[0].label
                    ? resolveLocalizedText(
                        errorCodeCICER24Config.buttons[0].label,
                      )
                    : ''}
                </button>
              </a>
              <button
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  gaClickAbleElement(
                    errorCodeCICER24Config.buttons &&
                      errorCodeCICER24Config.buttons[1] &&
                      errorCodeCICER24Config.buttons[1].label
                      ? resolveLocalizedText(
                          errorCodeCICER24Config.buttons[1].label,
                        )
                      : '',
                    ADDRESS_ERROR_CICER24,
                  );
                  this.hideErrorModal();
                }}
              >
                {errorCodeCICER24Config.buttons &&
                errorCodeCICER24Config.buttons[1] &&
                errorCodeCICER24Config.buttons[1].label
                  ? resolveLocalizedText(
                      errorCodeCICER24Config.buttons[1].label,
                    )
                  : ''}
              </button>
            </DialogFooter>
          </Dialog>
          {/* Chinese address case */}
          <Dialog
            show={inEligibleAddressUpdateReasonCode === ADDRESS_ERROR_CICER25}
          >
            <DialogHeader>
              {errorCodeCICER25Config.title
                ? resolveLocalizedText(errorCodeCICER25Config.title)
                : ''}
            </DialogHeader>
            <DialogBody>
              <div className="Non-HK-address-modal-content">
                <div className="Non-HK-address-modal-content-section1">
                  {errorCodeCICER25Config.desc
                    ? resolveLocalizedText(errorCodeCICER25Config.desc)
                    : ''}
                </div>
              </div>
            </DialogBody>
            <DialogFooter>
              <a target="_blank" rel="noopener noreferrer" href={downloadUrl}>
                <button
                  className="emma-stylesheet-primary-default-button"
                  onClick={() => {
                    gaClickAbleElement(
                      errorCodeCICER25Config.buttons &&
                        errorCodeCICER25Config.buttons[0] &&
                        errorCodeCICER25Config.buttons[0].label
                        ? resolveLocalizedText(
                            errorCodeCICER25Config.buttons[0].label,
                          )
                        : '',
                      ADDRESS_ERROR_CICER25,
                    );
                  }}
                >
                  {errorCodeCICER25Config.buttons &&
                  errorCodeCICER25Config.buttons[0] &&
                  errorCodeCICER25Config.buttons[0].label
                    ? resolveLocalizedText(
                        errorCodeCICER25Config.buttons[0].label,
                      )
                    : ''}
                </button>
              </a>
              <button
                className="emma-stylesheet-primary-ghost-button"
                onClick={() => {
                  gaClickAbleElement(
                    errorCodeCICER25Config.buttons &&
                      errorCodeCICER25Config.buttons[1] &&
                      errorCodeCICER25Config.buttons[1].label
                      ? resolveLocalizedText(
                          errorCodeCICER25Config.buttons[1].label,
                        )
                      : '',
                    ADDRESS_ERROR_CICER25,
                  );
                  this.hideErrorModal();
                }}
              >
                {errorCodeCICER25Config.buttons &&
                errorCodeCICER25Config.buttons[1] &&
                errorCodeCICER25Config.buttons[1].label
                  ? resolveLocalizedText(
                      errorCodeCICER25Config.buttons[1].label,
                    )
                  : ''}
              </button>
            </DialogFooter>
          </Dialog>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const { policy_number } = ownProps.match.params;
    const contactDetailsLabel = getContactDetailsLabels(state);
    const policyDetails = getContactDetailsPolicy(state, policy_number);
    const changeMobileLabels = getChangeMobileLabels(state);
    const errorCodeCICER21Config = getErrorCode(ADDRESS_ERROR_CICER21, state);
    const errorCodeCICER22Config = getErrorCode(ADDRESS_ERROR_CICER22, state);
    const errorCodeCICER24Config = getErrorCode(ADDRESS_ERROR_CICER24, state);
    const errorCodeCICER25Config = getErrorCode(ADDRESS_ERROR_CICER25, state);
    return {
      policyNumber: policy_number,
      policyDetails,
      contactDetailsLabel,
      changeMobileLabels,
      errorCodeCICER21Config,
      errorCodeCICER22Config,
      errorCodeCICER24Config,
      errorCodeCICER25Config,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      saveSelectedPolicy: (policy: any) => dispatch(saveSelectedPolicy(policy)),
      resetChangeEmailForm: () => dispatch(resetChangeEmailForm()),
      resetChangeMobileForm: () => dispatch(resetChangeMobileForm()),
      onSetUpIsHKAddressCase: (isHappyHKCase: boolean) => {
        dispatch(setUpIsHKAddressCase(isHappyHKCase));
      },
      onUpdateIsGoogleMapJsScriptError: (isError: boolean) => {
        dispatch(updateIsGoogleMapJsScriptError(isError));
      },
      clearAddressForm: () => {
        dispatch(clearAddressForm());
      },
    };
  }
}

export default connect(
  ContactDetailsContainer.mapStateToProps,
  ContactDetailsContainer.mapDispatchToProps,
)(ContactDetailsContainer);
